<template>
  <transition name="errorPeek">
    <div class="GlobalError" v-if="message">
      <p class="GlobalError-message">{{ message }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: "GlobalError",
  props: {
    message: {
      default: null,
      required: false,
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.GlobalError {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 10px;
  z-index: 10000;
  &-message {
    background-color: #ed4337;
    color: #fff;
    display: inline-block;
    padding: 8px 20px;
    border-radius: 6px;
  }
}
</style>
